/* eslint-disable linebreak-style */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';


import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import Icon from '@material-ui/icons/ArrowForward';
import CameraIcon from '@material-ui/icons/PhotoCamera';
import Input from '../../../../components/Input/Input';
import axios from '../../../../config/axiosInstance';

import { Container, TempGraphCont, Label, Hr, ButtonCustom, NumberLabel } from './styles';

import TemperatureChart from '../temperatureChart';
import EpiChart from '../epiChart';

function Temperature(props) {
  const [selectedDate, handleDateChange] = useState(new Date());
  const [feverNumber, setFeverNumber] = useState(null);
  const [epiNumber, setEpiNumber] = useState(null);
  const [epiData, setEpiData] = useState([]);
  const [data, setData] = useState([]);

  const formatDate = dt => format(dt, 'yyyy-MM-dd HH:mm:ss');


  useEffect(() => {
    async function fetchGraphs() {
      const dtRef = formatDate(selectedDate);
      const result = await axios.post(`/timeSheet/generate/pointSheet/dahsboard/facialRecognition/graph?dtRef=${dtRef}`);
      const hightFever = Object.assign(result.data[0], { color: '#EB5757', label: 'febre alta' });
      const lowFever = Object.assign(result.data[1], { color: '#F0B300', label: 'febre' });
      const epiGraph = Object.assign(result.data[2], { color: '#56CCF2', label: 'sem mascara' });

      setData([hightFever, lowFever]);
      setEpiNumber(result.data[2].value);
      setFeverNumber(Number(result.data[0].value) + Number(result.data[1].value));
      setEpiData([epiGraph]);
    }
    fetchGraphs();
    // console.log(result.data);
  }, [selectedDate]);

  const periodChange = (newDate) => {
    handleDateChange(newDate);
    props.onDateChange(newDate);
  };

  return (
    <Grid item xs={12}>
      <Container >
        <Grid item md={3} xl={5}>
          <div style={{
position: 'absolute', top: 1, display: 'flex', justifyContent: 'flex-start', left: -15,
}}
          >
            {
            props.notDash ?
              <Input
                elementType="datePicker"
                label="Data"
                margin="normal"
                value={selectedDate}
                onChange={date => periodChange(date)}
                color="white"
                style={{ position: 'absolute', marginLeft: 40, marginTop: 40 }}
              /> : <Typography variant="h6" style={{ position: 'absolute', marginLeft: 40, marginTop: 40 }}> Câmera Térmica </Typography>
          }


            <CameraIcon style={{
  color: 'rgba(255,255,255,0.1)', fontSize: 200, marginLeft: 0,
}}
            />
          </div>
        </Grid>

        <Grid item md={4} xl={3}>

          <TempGraphCont>
            <Label variant="body2">Funcionários com febre </Label>

            <div>
              <NumberLabel>{feverNumber}</NumberLabel>
              <TemperatureChart data={data} />
            </div>
          </TempGraphCont>
        </Grid>

        <Grid item md={1}>
          <Hr />
        </Grid>

        <Grid item md={4} xl={3}>
          <TempGraphCont>
            <Label variant="body2">Funcionários sem EPI </Label>
            <div>
              <NumberLabel>{epiNumber}</NumberLabel>

              <EpiChart data={epiData} />
            </div>
          </TempGraphCont>
        </Grid>

        {props.notDash ?

          null
          :
          <ButtonCustom
            component={Link}
            to="/cameratermica"
          >
            <Icon />
          </ButtonCustom>
        }

      </Container>
    </Grid>
  );
}

export default Temperature;
